// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__239S8","title":"AfterBackImages_title__2eoL0","images":"AfterBackImages_images__1XNp1"};